const environmentMap = {
    localhost: {
        oktaClientId: '0oa2audublpNRLMfR0h8',
        authBaseUrl: 'http://localhost:8080',
        userServiceUrl: 'http://localhost:8081',
        env: 'local',
        assetsBaseUrl: 'http://localhost:8082'
    },
    'myaccount-dev-dit.priv.devx-eks-stg.dht.live': {
        oktaClientId: '0oa2audublpNRLMfR0h8',
        authBaseUrl: 'https://dev-dit-amr-oneid-identity-oauth-agent.priv.amr-nonprod.devx-eks-stg.dht.live',
        userServiceUrl: '/identity-my-account-app-xsvc',
        env: 'dev-dit-amr',
        assetsBaseUrl: 'https://myaccount-dev-dit-amr-assets.resmed.com'
    },
    'myaccount-dev-fit.priv.devx-eks-stg.dht.live': {
        oktaClientId: '0oa2cv777maL43Wct0h8',
        authBaseUrl: 'https://dev-fit-amr-oneid-identity-oauth-agent.priv.amr-nonprod.devx-eks-stg.dht.live',
        userServiceUrl: '/identity-my-account-app-xsvc',
        env: 'dev-fit-amr',
        assetsBaseUrl: 'https://myaccount-dev-fit-amr-assets.resmed.com'
    },
    'myaccount-e2e-perf.priv.devx-eks-stg.dht.live': {
        oktaClientId: '0oa2cv7awjmsoGxvC0h8',
        authBaseUrl: 'https://e2e-perf-amr-oneid-identity-oauth-agent.priv.amr-nonprod.devx-eks-stg.dht.live',
        userServiceUrl: '/identity-my-account-app-xsvc',
        env: 'e2e-perf-amr',
        assetsBaseUrl: 'https://myaccount-e2e-perf-amr-assets.resmed.com'
    },
    'myaccount-stg.resmed.com': {
        oktaClientId: '0oal4r6eb5UKsh2Bu1d7',
        authBaseUrl: 'https://oauth-agent-api-stg.resmed.com',
        userServiceUrl: '/identity-my-account-app-xsvc',
        env: 'e2e-stg-amr',
        assetsBaseUrl: 'https://myaccount-e2e-stg-amr-assets.resmed.com'
    },
    'myaccount.resmed.com': {
        oktaClientId: '0oa12yyryrfIK5PjN298',
        authBaseUrl: 'https://oauth-agent-api.resmed.com',
        userServiceUrl: '/identity-my-account-app-xsvc',
        env: 'prod-amr',
        assetsBaseUrl: 'https://myaccount-assets.resmed.com'
    }
};
const getEnvironmentConfig = () => {
    try {
        const hostname = globalThis.location.hostname;
        const config = environmentMap[hostname];
        if (config) {
            return config;
        }
    }
    catch (_a) {
        // In non-browser environments (e.g. tests), location may be missing or partial.
    }
    return environmentMap.localhost;
};
export const environmentConfig = getEnvironmentConfig();
